import React from 'react';
import styles from './styles.scoped.css';
import { analytics } from '../../../utils/firebase';
import { propTypes } from './constants';
import { Select as SelectMantine } from '@mantine/core';
import IconArrowDown from '../../icons/IconArrowDown';
import { logEvent } from 'firebase/analytics';
function Select(props) {
  const {
    className,
    data,
    disabled,
    eventName,
    hideLabel,
    input,
    inputProps,
    onChange,
    value,
    icon,
  } = props;

  const label = input?.value && !hideLabel;
  const notEmpty = label ? styles['not-empty'] : '';
  const classes = [
    'root',
    className,
    notEmpty,
    icon === 'chevron' ? 'chevronDown' : '',
  ]
    .filter(Boolean)
    .join(' ');

  const onSelectChange = (event) => {
    logEvent(analytics, eventName, {
      value: event,
    });

    onChange(event);
  };
  return (
    <SelectMantine
      className={classes}
      data={data || []}
      defaultValue={value}
      value={value}
      {...input}
      {...inputProps}
      disabled={disabled}
      onChange={onSelectChange}
      rightSection={inputProps?.rightSection || <IconArrowDown />}
    />
  );
}

Select.propTypes = { ...propTypes };

// Provide defaultProps to satisfy tests that call Select.defaultProps.onChange()
Select.defaultProps = {
  className: '',
  data: [],
  disabled: false,
  eventName: '',
  hideLabel: false,
  input: {},
  inputProps: {},
  // No-op onChange so tests can call Select.defaultProps.onChange()
  onChange: () => {},
  value: undefined,
  icon: undefined,
};

export default Select;
